import React, { useEffect } from 'react'
import styles from './index.module.css'
import Modal from 'react-responsive-modal'
import ModalFooter from '../../../../../components/ModalFooter/ModalFooter'
import { Input, Select } from '../../../../../components/ModalInputs'
import { useDispatch, useSelector } from 'react-redux'
import { getStudyPlanList, getStudyTrackProfile } from '../../../../../actions/studyPlans'
import * as Yup from 'yup'

import { useFormik } from 'formik'

const validationSchema = Yup.object().shape({
    cid: Yup.string().required('обязательное поле'),
    prev_cid: Yup.string().required('обязательное поле'),
    xp_hours: Yup.number().required('обязательное поле').min(1, 'Минимум 1'),
    xp_hours_period: Yup.number().required('обязательное поле').min(1, 'Минимум 1'),
    xp_hours_year: Yup.number().required('обязательное поле').min(1, 'Минимум 1'),
    level: Yup.number().required('обязательное поле').min(1, 'Минимум 1'),
    profile_id: Yup.string().required('обязательное поле'),
})

const Index = ({ modalOpen, setModalOpen, closeModal, }) => {

    const dispatch = useDispatch()

    const { fullList = [], track_profile = [] } = useSelector(state => state.studyPlans)

    const handleCreate = (values) => {
        closeModal()
        // dispatch(createAdmissionComitet(removeUnnecessaryKey({ ...values }, ...keysToDelete)))
        // setCreated(values)
    }

    const handleUpdate = (values) => {
        // dispatch(updateAdmissionComitet((removeUnnecessaryKey({ ...values }, ...keysToDelete))))
        closeModal()
        // setSelectedItem(null)
        // setCreated(null)
    }

    const {
        values,
        errors,
        touched,
        submitCount,
        handleChange,
        handleSubmit,
    } = useFormik({
        initialValues: modalOpen?.trid ? modalOpen : {}, // беру полную инфу на комиссию для все вкладок
        enableReinitialize: true,
        validateOnChange: true,
        validationSchema: validationSchema,
        onSubmit: modalOpen?.trid ? handleCreate : handleUpdate
    })

    useEffect(() => {
        dispatch(getStudyPlanList());
        dispatch(getStudyTrackProfile());
    }, [])


    const renderOptions = ({ title, cid, xp_key }) => <option value={cid} key={xp_key}>{title}</option>
    const renderOptions_ = ({ trp_id, name }) => <option value={trp_id} key={trp_id}>{name}</option>

    const checkProfile = () => {
        let x = false
        if (modalOpen.xp_key === 'new') {
            if (modalOpen?.profile_id === '' || modalOpen?.profile_id === 0) {
                x = true
            } else {
                x = false
            }
        } else {
            if (modalOpen?.profile_id === '' || modalOpen?.profile_id === 0) {
                x = true
            } else {
                x = false
            }
        }
        return x
    }

    const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

    return (
        <Modal
            classNames={{
                modal: styles.modalMain
            }}
            open={modalOpen}
            onClose={closeModal}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            showCloseIcon={true}
            animationDuration={1}
            style={{
                modal: {
                    background: 'white',
                    width: '700px'
                }
            }}
        >

            <div className={styles.modalContent}>
                <h1 className={styles.modalHeader}>{modalOpen?.xp_key != 'new' ? 'Изменить' : 'Создать'}</h1>
                <div className={styles.modalMenu}>
                    <div className={styles.inputsRow}>
                        <Select
                            error={error('cid')}
                            label='Предмет'
                            name='cid'
                            value={values?.cid}
                            onChange={e => handleChange({ target: { name: 'cid', value: Number(e.target.value) } })}>
                            {[{ cid: '', title: 'Выбрать' }, ...fullList]?.map(renderOptions)}
                        </Select>
                    </div>

                    <div className={styles.inputsRow}>
                        <Select
                            error={error('prev_cid')}
                            label='Предшествующий предмет'
                            name='prev_cid'
                            value={values?.prev_cid}
                            onChange={e => handleChange({ target: { name: 'prev_cid', value: Number(e.target.value) } })}>
                            {[{ cid: '', title: 'Выбрать' }, ...fullList]?.map(renderOptions)}
                        </Select>
                    </div>

                    <div className={styles.tabWrapper}>
                        <div className={styles.inputsRow}>
                            <Input
                                type='text'
                                error={error('xp_hours')}
                                label='Часов в неделю'
                                maxLength={9}
                                onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
                                name='xp_hours'
                                value={values.xp_hours}
                                onChange={e => handleChange(e)} />
                        </div>
                        <div className={styles.inputsRow}>
                            <Input
                                type='text'
                                error={error('xp_hours_period')}
                                label='Часов в период'
                                maxLength={9}
                                onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
                                name='xp_hours_period'
                                value={values.xp_hours_period}
                                onChange={e => handleChange(e)} />
                        </div>
                        <div className={styles.inputsRow}>
                            <Input
                                type='text'
                                error={error('xp_hours_year')}
                                label='Часов в год'
                                maxLength={9}
                                onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
                                name='xp_hours_year'
                                value={values.xp_hours_year}
                                onChange={e => handleChange(e)} />
                        </div>
                    </div>

                    <div className={styles.tabWrapper}>
                        <div className={styles.inputsRow}>
                            <Input
                                type='text'
                                error={error('level')}
                                label='Параллель'
                                maxLength={9}
                                onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
                                name='level'
                                value={values.level}
                                onChange={e => handleChange(e)} />
                        </div>
                        <div className={styles.inputsRow}>
                            <Select
                                error={error('profile_id')}
                                label='Профиль'
                                name='profile_id'
                                value={values?.profile_id}
                                onChange={e => handleChange({ target: { name: 'profile_id', value: Number(e.target.value) } })}>
                                {[...track_profile]?.map(renderOptions_)}
                            </Select>
                        </div>

                    </div>

                </div>
            </div>

            <ModalFooter isShowInfo={true} closeModal={closeModal} handleSubmit={handleSubmit}
            />
        </Modal>
    )
}

export default Index